<script lang="ts">
  import Typography from "../Typography.svelte";
  import { TypographyType } from "../../lib/constants/typographyMap";
  import { sessionStore, setLanguage } from "../../lib/stores/session";
  import { getLanguageNativeName } from "../../lib/helpers/language";
  import Tick from "../../assets/icons/tick.svg";

  export let isoCode: string;
  export let onSelect: () => void = () => "do nothing";

  const onClick = () => {
    setLanguage(isoCode);
    onSelect();
  };

  $: languageDisplayName = getLanguageNativeName(isoCode);
  $: selected = $sessionStore.language === isoCode;
</script>

<button class="relative item flex px-4 flex-row items-center gap-2 w-full rounded-lg" class:selected on:click|stopPropagation={onClick}>
  <div class="w-full text-left">
    <Typography mobile={TypographyType.Headline5Medium} desktop={TypographyType.Headline5Medium} copy={languageDisplayName} />
  </div>
  <img src={Tick} class="w-4 h-4" class:hidden={!selected} alt="" />
</button>

<style>
  .selected {
    background-color: var(--color-grayscale-10);
  }

  .item {
    padding-top: 1.125rem;
    padding-bottom: 1.125rem;
  }
</style>
